import classnames from 'classnames';

type PanelTitleProps = {
  children: React.ReactNode;
  className?: string;
  size?: string;
  bottomBorder?: boolean;
};

export default function PanelTitle({ children, className, size, bottomBorder }: PanelTitleProps) {
  const classes = classnames('panel-title', className, {
    [`title-${size}`]: !!size,
    bottomBorder: bottomBorder,
  });
  return <div className={classes}>{children}</div>;
}
